let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1NIhh")).then(() => parcelRequire('dCJZe'));